export { HomePage } from './home/home';
export { ItemPage } from './item/page';
export { LocationPage } from './location/page';
export { ConditionPage } from './condition/page';
export { ClassificationPage } from './classification/page';
export { AssetPage } from './asset/page';
export { FormItemPage } from './form_item/page';
export { DetailItemPage } from './detail_item/page';
export { ScanCodePage } from './scan_code/page';
export { PrintCodePage } from './print_code/page';
export { FormClassificationPage } from './form_classification/page';
export { FormLocationPage } from './form_location/page';
export { TrackingPage } from './tracking/page';
export { PicPage } from './pic/page';
export { ReportPage } from './report/page';
export { ProfilePage } from './profile/page';
export { ReviewPage } from './reviews/page';
export { DepartmentPage } from './department/page';
export { DetailImagePage } from './detail_image/page';
export { FinishOpnamePage } from './finish_opname/page';
export { LoginPage } from './login/page';
export { ProjectPage } from './project/page';
export { AboutPage } from './about/page';
export { FormReviewPage } from './form_review/page';
export { DetailReviewPage } from './detail_reviews/page';
export { ActivityPage } from './activity/page';
export { DetailItemERPPage } from './detail_item_erp/page';

export { AssetReviewsPage } from './asset_reviews/page';
export { SelectPage } from './select/page';
export { AssetDocumentsPage } from './asset_documents/page';
export { FormDocumentsPage } from './form_documents/page';

export { AssignmentPage } from './assignment/page';
export { AssignmentResPage } from './assignment_result/page';
export { FormAssignmentPage } from './form_assignment/page';
export { LsAssignmentPage } from './ls_assignment/page';



// WEBPACK FOOTER //
// ./src/pages/asset/index.ts